(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-links"]) return;
  try {
    
  const syncFooterLinkAccordions = (root = document) => {
    const sections = [...root.querySelectorAll('.footer-links')].filter((section) => {
      if (section.dataset.accordionReady === 'true') return false;
      section.dataset.accordionReady = 'true';
      return true;
    });
    if (!sections.length) return;

    const desktop = window.matchMedia('(min-width: 750px)');

    sections.forEach((section) => {
      const columns = [...section.querySelectorAll('.footer-links__column')];

      const apply = () => {
        columns.forEach((column) => {
          if (desktop.matches) column.setAttribute('open', '');
          else column.removeAttribute('open');
        });
      };

      apply();
      desktop.addEventListener('change', apply);

      columns.forEach((column) => {
        column.addEventListener('toggle', () => {
          if (desktop.matches && !column.open) column.setAttribute('open', '');
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncFooterLinkAccordions());
  } else {
    syncFooterLinkAccordions();
  }

  document.addEventListener('shopify:section:load', (event) => {
    syncFooterLinkAccordions(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-picks"] && !Shopify.designMode) return;
  try {
    
  const bindProductPickPages = (root) => {
    if (!root || root.dataset.pagesReady === 'true') return;
    root.dataset.pagesReady = 'true';

    root.querySelectorAll('.product-picks__panel').forEach((panel) => {
      const grid = panel.querySelector('.product-picks__grid');
      const pages = [...panel.querySelectorAll('.product-picks__page')];
      if (!grid || pages.length < 2) return;

      const setActive = (index) => {
        pages.forEach((button, buttonIndex) => {
          if (buttonIndex === index) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      };

      const pageIndex = () => {
        const origin = grid.getBoundingClientRect().left;
        let index = 0;
        let best = Infinity;

        pages.forEach((_, candidate) => {
          const item = grid.children[candidate * 4];
          if (!item) return;
          const distance = Math.abs(item.getBoundingClientRect().left - origin);
          if (distance < best) {
            best = distance;
            index = candidate;
          }
        });

        return index;
      };

      let frame = 0;
      grid.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => setActive(pageIndex()));
        },
        { passive: true }
      );

      pages.forEach((button, index) => {
        button.addEventListener('click', () => {
          const item = grid.children[index * 4];
          if (!item) return;
          const left = grid.scrollLeft + item.getBoundingClientRect().left - grid.getBoundingClientRect().left;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          grid.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
          setActive(index);
        });
      });
    });
  };

  const startProductPickPages = () => {
    document.querySelectorAll('.product-picks').forEach(bindProductPickPages);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startProductPickPages);
  } else {
    startProductPickPages();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindProductPickPages(event.target.querySelector('.product-picks'));
  });

  } catch(e) { console.error(e); }
})();
})();
